import { AccessToken, Account } from '../models';
import { Partner } from '../models/partner.model';
import { getToken, validateAndExtractData } from './api.base.service';

export const login = async ({
  email,
  password
}: {
  email?: string;
  password?: string;
}) => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}account/login`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, password })
    }
  );
  const login: AccessToken = await validateAndExtractData(response);
  if (login?.access_token) {
    localStorage.setItem('realgenius:token', JSON.stringify(login));
  }
  return login;
};

export const getAccount = async (id: string) => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}account/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      }
    }
  );
  const account: Account = await validateAndExtractData(response);
  return account;
};

export const patchAccount = async (id: string, data: Partial<Account>) => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}account/${id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      },
      body: JSON.stringify(data)
    }
  );
  const responseData = await validateAndExtractData(response);
  return responseData;
};

export const signup = async (account: Partial<Account>) => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}account/signup`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(account)
    }
  );
  const login: AccessToken = await validateAndExtractData(response);
  if (login?.access_token) {
    localStorage.setItem('realgenius:token', JSON.stringify(login));
  }
  return login;
};

export const individualRealtorSignup = async (account: Partial<Account>) => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}account/realtor-signup`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(account)
    }
  );
  const accountCreated: Account = await validateAndExtractData(response);
  return accountCreated;
};

export const validateAccount = async (token: string) => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}account/validate`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ token })
    }
  );
  const responseData = await validateAndExtractData(response);
  return responseData;
};

export const getAccounts = async (): Promise<Account[]> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}account`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      }
    }
  );
  const accounts: Account[] = await validateAndExtractData(response);
  return accounts;
};

export const getAccountPartners = async (id: string): Promise<Partner[]> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}account/${id}/partners`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      }
    }
  );
  const partners: Partner[] = await validateAndExtractData(response);
  return partners;
};

export const updateAccountPartners = async (
  id: string,
  partnerIds: string[]
): Promise<Account> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}account/${id}/partners`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      },
      body: JSON.stringify({ partnerIds })
    }
  );
  const account: Account = await validateAndExtractData(response);
  return account;
};

export const setAccountActive = async (
  id: string,
  active: boolean
): Promise<Account> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}account/${id}/active`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      },
      body: JSON.stringify({ active })
    }
  );
  const account: Account = await validateAndExtractData(response);
  return account;
};

export const deleteAccount = async (id: string) => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}account/admin/${id}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      }
    }
  );
  const responseData = await validateAndExtractData(response);
  return responseData;
};
